import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { userLogout } from "../../Actions/Users/UserActions";
import Button from "../../Common/Buttons/Button";
import NiceError from "../../Common/Errors/NiceError";
import { type RootState } from "../../Reducers/ShopfrontReducers";
import { getLogLevel, LogLevel } from "../../Utilities/Platform/Logging";

function mapStateToProps(state: RootState): {
    user?: {
        id: string;
        name: string;
    };
} {
    return {
        user: state.user.id === false ? undefined : {
            id  : state.user.id,
            name: state.user.name,
        },
    };
}

const connector = connect(mapStateToProps);

type Props = ConnectedProps<typeof connector> & typeof FourZeroThree.defaultProps & {
    dispatch: ThunkDispatch<any, any, any>;
};

class FourZeroThree extends React.Component<Props> {
    public static defaultProps: {
        permissions: ReadonlyArray<string>;
    } = {
        permissions: [],
    };

    constructor(props: Props) {
        super(props);

        this.handleChangeUser = this.handleChangeUser.bind(this);
    }

    protected handleChangeUser(): void {
        if(getLogLevel() === LogLevel.VERBOSE) {
            console.log("Logging out on 403 screen (button press)");
        }

        this.props.dispatch(userLogout(true));
    }

    public render(): React.ReactNode {
        const actions = [];

        if(typeof this.props.user !== "undefined") {
            actions.push(
                <Button
                    onClick={this.handleChangeUser}
                    classes={[ "button-primary" ]}
                >
                    Change User
                </Button>
            );
        }

        return (
            <div className="vertical-center">
                <NiceError
                    icon="lock-alt"
                    title="403: Permission Denied"
                    actions={actions}
                >
                    <p>Unfortunately you do not have permission to access this feature.</p>
                    {typeof this.props.user !== "undefined" && (
                        <p>You&#39;re currently logged in as {this.props.user.name}</p>
                    )}
                </NiceError>
            </div>
        );
    }
}

export default connector(FourZeroThree);
